module.exports = __webpack_public_path__ + "static/media/zoneAdminCertifiedIcon.daafa9ba.svg";